import {get, post} from '@/lib/axios';

const tests = {
  /** Вопросы теста
   * @param {number} id - id назначенного проверочного теста.
   */
  async get_questions(id) {
    return get(`/tests/questions/${id}`);
  },
  /** Назначенные тесты для текущего пользователя, где status - статус из hl блока "Пройденные курсы" */
  async get_tests(status = 'all') {
    return get(`/tests/${status}`);
  },
  /** Роут для получения курса по id */
  async get_assigned_test_by_id(courseId) {
    return get(`/tests/getUsersAssignedTest/${courseId}`);
  },
  /** Проверить ответы на тест */
  async post_check_answers(data) {
    return post('/tests/checkAnswers', data);
  },
  /** Роут для таблиц "Клиентская часть ответственное лицо организации/заместитель ответственного лица" и "Раздел Обучение сотрудников" */
  async get_all_assigned_courses(data) {
    return post('/tests/getAllAssignedCourses', data);
  },
  /** Роут для таблицы "Клиентская часть сотрудник академии, администратор" */
  async get_completed_courses(data) {
    return post('/tests/getCompletedCourses', {
      page_size: data.page_size,
      page     : data.page_num,
      filter   : {
        fio                : data.name,
        dateAppointmentFrom: data.dateAppointmentFrom,
        dateAppointmentTo  : data.dateAppointmentTo,
        dateExpirationFrom : data.dateCompletionFrom,
        dateExpirationTo   : data.dateCompletionTo,
        courseId           : data.test_id,
        organizationId     : data.organization,
      },
      sortBy   : data.sortBy,
      sortOrder: data.sortOrder,
    });
  },
  /** Роут названий и id всех компаний и курсов (тестов) */
  async get_all_organizations_courses() {
    return get('/tests/getAllOrganizationsCourses');
  },
  /** Создать новый назначенный проверочный тест */
  async create_assigned_test({testId, companiesIds, appointmentDate}) {
    return post('/tests/createAssignedTest', {testId, companiesIds, appointmentDate});
  },
  /** Удалить назначенный проверочный тест */
  async delete_assigned_test(testIds) {
    return post('/tests/deleteAssignedTest', {testIds});
  },
};

export {tests as default};
